import { ViewMoneyMap } from '../../../roadmap/components/money-map/ViewMoneyMap';

export default function ViewMoneyMapScreen() {
    return <ViewMoneyMap />;
}
